import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { API_ASSIGNATURE } from '../../app.api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../error/error.service';
import { Any, GetDocument, SignatureModel } from 'src/app/shared/models/signature.model';

@Injectable({
  providedIn: 'root'
})
export class SignatureService extends ErrorService {

  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }

  postSignature(cpf:string,imageBlob:string,typeImage:string,uidSigner:string,uidDoc:string,fullname:string,
    bornDate:string,longitude:string,latitude:string): Observable<any> {
    var fd = new FormData();
    fd.append('cpf', cpf);
    fd.append('imageBlob', imageBlob);
    fd.append('typeImage', typeImage);
    fd.append('uidSigner', uidSigner);
    fd.append('uidDoc', uidDoc);
    fd.append('fullname', fullname);
    fd.append('bornDate', bornDate);
    fd.append('longitude', longitude);
    fd.append('latitude', latitude);
    return this.http.post<any>(`${API_ASSIGNATURE}/api/v1/sign`, 
      fd,
      {observe: 'response',
       headers: new HttpHeaders({
          "Access-Control-Allow-Origin": "*"
        })
      }
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  postUploadFile(file:any, name:string, type:string): Observable<SignatureModel> {
    return this.http.post<SignatureModel>(`${API_ASSIGNATURE}/api/v1/upload/document`, 
      {
        dto: {
          typeFile: type,
          name: name,
          fileBlob: file
        }
      }
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  postConverter(blob:string, type:string): Observable<Any> {
    return this.http.post<Any>(`${API_ASSIGNATURE}/api/v1/converter`, 
      {
        dto: {
          typeFile: type,
          fileBlob: blob
        }
      }
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  download(uidDoc:string, type:string): Observable<Any> {
    return this.http.get<Any>(`${API_ASSIGNATURE}/api/v1/download/document/${uidDoc}/type/${type}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  postAssociateSubscriber(email:string, uid:string): Observable<Any> {
    return this.http.post<Any>(`${API_ASSIGNATURE}/api/v1/assign-signer`, 
      {
        dto: {
          subscriber: {
            email: email
          },
          uid: uid
        }
      }
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  listDocuments(): Observable<any> {
    return this.http.get<any>(`${API_ASSIGNATURE}/api/v1/documents`, {observe: 'response'})
  }

  getDocument(uidDoc:string, uidSigner:string): Observable<GetDocument> {
    return this.http.get<GetDocument>(`${API_ASSIGNATURE}/api/v1/document/${uidDoc}/signer/${uidSigner}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  getSignatureSubscriber(uidSigner:string): Observable<GetDocument> {
    return this.http.get<GetDocument>(`${API_ASSIGNATURE}/api/v1/signature/${uidSigner}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  verifyDigitalSignature(uid:string, sha:string, typeSha:string): Observable<Any> {
    return this.http.post<Any>(`${API_ASSIGNATURE}/api/v1/digital-signature`, 
      {
        dto: {
          uid: uid,
          sha: sha,
          typeSha: typeSha
        }
      }
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  recendEmail(uidSigner:string, uidDoc:string): Observable<GetDocument> {
    return this.http.get<GetDocument>(`${API_ASSIGNATURE}/api/v1/recend-email/document/${uidDoc}/signer/${uidSigner}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  complete(uidDoc:string): Observable<any> {
    return this.http.get<any>(`${API_ASSIGNATURE}/api/v1/complete/document/${uidDoc}`)
      .pipe(
        catchError(this.handleError)
      );
  }
}
